import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded',function() {

    var swiper = new Swiper(".orange-contest__slider", {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 6000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper2 = new Swiper(".orange-contest__contest-list-slider", {
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        spaceBetween: 31,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper = new Swiper(".play-contest__slider", {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 6000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper2 = new Swiper(".play-contest__contest-list-slider", {
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        spaceBetween: 31,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper4 = new Swiper(".t-mobile-contest__slider", {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 6000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper5 = new Swiper(".t-mobile-contest__contest-list-slider", {
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        spaceBetween: 31,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper4 = new Swiper(".plus-contest__slider", {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 6000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    var swiper5 = new Swiper(".plus-contest__contest-list-slider", {
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        spaceBetween: 31,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });


    var swiper5 = new Swiper(".lp-subpage__opinions-items-slider", {
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        spaceBetween: 20,
    });

    var swiper5 = new Swiper(".lp-subpage__phones-items-slider", {
        slidesPerView: 'auto',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        spaceBetween: 20,
    });

    const allSmoothLinks = document.getElementsByClassName('smooth-js');
    const allSmoothTarget = document.getElementsByClassName('smooth-target-js');

    if(allSmoothLinks) {
        for(let i = 0; i < allSmoothLinks.length; i++) {
            allSmoothLinks[i].addEventListener('click',function(ev) {
                ev.preventDefault();
                for(let j = 0; j < allSmoothTarget.length; j++) {
                    if(allSmoothLinks[i].dataset.click == allSmoothTarget[j].dataset.target) {
                        window.scroll({
                            top : allSmoothTarget[j].getBoundingClientRect().top + window.scrollY - 40,
                            left : 0,
                            behavior : 'smooth'
                        });
                    }
                }
            })
        }
    }

    const burgerOpen = document.querySelectorAll('.orange-contest__header-burger, .play-contest__header-burger, .t-mobile-contest__header-burger')[0];
    const burgerWrapper = document.querySelectorAll('.orange-contest__burger-menu, .play-contest__burger-menu, .t-mobile-contest__burger-menu')[0];
    const burgerClose = document.querySelectorAll('.orange-contest__burger-menu-wrapper-close, .play-contest__burger-menu-wrapper-close, .t-mobile-contest__burger-menu-wrapper-close')[0];
    const burgerItems = document.querySelectorAll('.orange-contest__burger-menu-wrapper-list-item, .play-contest__burger-menu-wrapper-list-item, .t-mobile-contest__burger-menu-wrapper-list-item');

    if(burgerOpen) {
        burgerOpen.addEventListener('click', function() {
            if(burgerWrapper) {
                burgerWrapper.classList.add('active');
            }
        })
    }

    if(burgerClose) {
        burgerClose.addEventListener('click', function() {
            if(burgerWrapper) {
                burgerWrapper.classList.remove('active');
            }
        })
    }

    if(burgerItems) {
        for(var i = 0; i < burgerItems.length; i++) {
            burgerItems[i].addEventListener('click',function() {
                if(burgerWrapper) {
                    if(burgerWrapper.classList.contains('active')) {
                        burgerWrapper.classList.remove('active');
                    }
                }
            })
        }
    }


    // Toggle faq items

    const toggleTitles = document.getElementsByClassName('js-faq-title');

    if(toggleTitles) {
        for(var i = 0; i < toggleTitles.length; i++) {
            toggleTitles[i].addEventListener('click', function() {

                if(this.classList.contains('active')) {
                    this.classList.remove('active');
                } else {
                    this.classList.add('active');
                }

            })
        }
    }

    const burgerOpenOrange = document.querySelectorAll('.lp-subpage-header__burger')[0];
    const burgerWrapperOrange = document.querySelectorAll('.lp-subpage__burger-menu')[0];
    const burgerCloseOrange = document.querySelectorAll('.lp-subpage__burger-menu-wrapper-close')[0];
    const burgerItemsOrange = document.querySelectorAll('.lp-subpage__burger-menu-wrapper-menu-list-item');

    if(burgerOpenOrange) {
        burgerOpenOrange.addEventListener('click', function() {
            if(burgerWrapperOrange) {
                burgerWrapperOrange.classList.add('active');
            }
        })
    }

    if(burgerCloseOrange) {
        burgerCloseOrange.addEventListener('click', function() {
            if(burgerWrapperOrange) {
                burgerWrapperOrange.classList.remove('active');
            }
        })
    }

    if(burgerItemsOrange) {
        for(var i = 0; i < burgerItemsOrange.length; i++) {
            burgerItemsOrange[i].addEventListener('click',function() {
                if(burgerWrapperOrange) {
                    if(burgerWrapperOrange.classList.contains('active')) {
                        burgerWrapperOrange.classList.remove('active');
                    }
                }
            })
        }
    }

})